import React, { FC, useState } from "react";
import { IBankForAdd } from "../../../../store/slice/requestAppSlise/requestAppSlise";
import { Alert, Button, Modal } from "antd";
import { BankListInApplicationInfo } from "./BankListInApplicationInfo/BankListInApplicationInfo";

interface IBankListInApplicationInfoModal {
  preferedBanks: IBankForAdd[];
  alertTitle: string;
}
export const BankListInApplicationInfoModal: FC<
  IBankListInApplicationInfoModal
> = ({ preferedBanks, alertTitle }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      {preferedBanks && (
        <>
          <Alert
            message={alertTitle}
            type="info"
            showIcon
            action={
              <Button size="small" type="link" onClick={showModal}>
                Просмотреть список
              </Button>
            }
          />
          <Modal
            title="Предпочтения по отправке в банки"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
          >
            <BankListInApplicationInfo preferedBanks={preferedBanks} />
          </Modal>
        </>
      )}
    </>
  );
};
